import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'PictureCardContainer'

    static propTypes = {
      error: PropTypes.bool.isRequired,
      index: PropTypes.number.isRequired,
      pending: PropTypes.bool.isRequired,
      picture: PropTypes.object.isRequired,
      rug: PropTypes.object.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      setPrimary: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      uploadDesignerPicture: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    setPrimary = () => {
      const { picture, setPrimary } = this.props

      setPrimary(picture.id)
    }

    togglePreview = () => {
      const { index, setCurrentIndex, togglePreview } = this.props

      setCurrentIndex(index)
      togglePreview()
    }

    uploadDesignerPicture = e => {
      const { rug, picture, uploadDesignerPicture, user } = this.props
      const formData = new FormData()

      const file = e.target.files[0]

      if (file) {
        formData.set('pictureId', picture.id)
        formData.set('rugId', rug.id)
        formData.set('userId', user.id)
        formData.set('designerPicture', file, file.name)

        uploadDesignerPicture(formData, picture.id)
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          setPrimary={this.setPrimary}
          togglePreview={this.togglePreview}
          uploadDesignerPicture={this.uploadDesignerPicture}
        />
      )
    }
  }

  return Container
}
